import React from 'react'
import coupon from "../../assets/images/home/COUPON.svg"
import HomeSlider from '../../components/ui/HomeSlider'
import coin from '../../assets/images/home/coin.svg'
import { useLocation } from 'react-router'
import BoxSlider from '../../components/ui/BoxSlider'

const Home = () => {
  const boxes = Array(7).fill(null);
  const location = useLocation();

  return (
    <div className="bg_body">
      <div className='xl:container xl:mx-auto mx-4'>
        <div className="flex flex-col home_hero relative h-[50vh] lg:h-[80vh]">
          <h1 className=" ">
            Good Standing Connects the people who <span>can help</span> to the people who <span>need help</span>
          </h1>

          <p className="text-4xl">
            Sign up. Complete tasks. Earn rewards.
          </p>

          <div className="w-fit mt-auto ml-auto mb-10 font_dafoe text-5xl lg:text-[100px] text-[#6EAB5E]">
            Are You In?
          </div>

        </div>

      </div>


      {
        location.pathname === '/organization' ? (
          <div className="second_section border-y-2 border_dark bg_clip">
            <div className="grid grid-cols-1 gap-10 py-12  lg:container lg:mx-auto mx-4 lg:px-16">
              <div className="bg-[#FFEBEF] border border_dark py-[28px] px-[33px] flex items-center flex-col text-center rounded-3xl shadow-md ">
                <h3>I need help</h3>

                <p >
                  Post a task and get help from volunteers in your <br /> community.
                </p>

                <button className="px-6 py-2 rounded-lg w-fit text-white bg-[#0A3400]">
                  Request Assistance
                </button>
              </div>

            </div>

          </div>
        ) : (
          <div className="second_section border-y-2 border_dark bg_clip">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10 py-12  lg:container lg:mx-auto mx-4 lg:px-16">
              <div className="bg-[#FFEBEF] border border_dark py-[28px] px-[33px]  rounded-3xl shadow-md ">
                <h3 >I CAN HELP</h3>

                <p >
                  Find tasks that match your skills and help organizations near you.
                </p>

                <button className="px-6 py-2 rounded-lg w-fit text-white bg-[#0A3400]">
                  Find Task
                </button>
              </div>

              <div className="bg-[#FFEBEF] border border_dark p-8 rounded-3xl shadow-md ">
                <h3 >I NEED HELP</h3>

                <p >
                  Post a task and get help from volunteers in your community.
                </p>

                <button className="px-6 py-2 rounded-lg w-fit text-white bg-[#0A3400]">
                  Request Assistance
                </button>
              </div>

            </div>
          </div>
        )
      }

      <div className="lg:container lg:mx-auto mx-4 pt-16">
        <div className="flex-1">
          <h2 className="font-bold" >track your impact & earn rewards for doing good</h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center py-16">

          <div className='relative ml-16 '>
            <img src={coin} alt="Voucher" className="absolute left-[-70px] sm:left-[-100px] top-[-30px] w-[120px] sm:w-[160px] h-auto" />
            <img src={coupon} alt="Voucher" className="w-[300px] sm:w-[368px] h-auto " />
          </div>

          <p className='mt-8 lg:mt-0 lg:w-[60%] text-xl ml-auto font_ovo'>As you complete more tasks, you’ll unlock badges that will be collected and displayed on your profile. You can also complete challenges to earn coupons for real-life goods and experiences, provided by our sponsors.</p>
        </div>
      </div>

      <div className='border-y-2 border_dark py-16'>

        <div className="lg:container  lg:mx-auto mx-4 home_slider ">
          <h2 className="items-center font-bold flex flex-col text-[#362269]">OUR Sponsors</h2>

          <div className='py-8 md:py-[60px]'>
            <HomeSlider />
          </div>

          <button className="px-6 py-2 rounded-lg w-fit text-white bg-[#362269] mx-auto flex ">
            Sponsor a Community Challenge
          </button>
        </div>
      </div>

      <div className='py-16 bg-[#F6F2EF]'>
        <h2 className='text-center text-xl md:text-2xl lg:text-3xl font-bold mb-16'>
          Read Some Good News
        </h2>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 lg:container lg:mx-auto mx-4'>
          <div className='bg-[#6EAB5E] border-dark border-2 max-w-[90%] mx-auto h-[300px] lg:h-[400px]  rounded-lg flex justify-center items-center text-center p-8'>
            <h2 className=''>
              Co-op gets a fresh paint job
            </h2>
          </div>

          <div className='bg-[#6EAB5E] border-dark border-2 max-w-[90%] mx-auto h-[300px] lg:h-[400px]  rounded-lg flex justify-center items-center text-center p-8'>
            <h2 className=''>
              Community garden in the Bronx is officially open!
            </h2>
          </div>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-6 mb-16 lg:container lg:mx-auto mx-4'>
          <div className='bg-[#6EAB5E] border-dark border-2 max-w-[90%] mx-auto h-[300px] lg:h-[400px]  rounded-lg flex justify-center items-center text-center p-8'>
            <h2 className=''>
              Kids in need receive new backpacks ahead of the new school year
            </h2>
          </div>

          <div className='bg-[#6EAB5E] border-dark border-2 max-w-[90%] mx-auto h-[300px] lg:h-[400px]  rounded-lg flex justify-center items-center text-center p-8'>
            <h2 className=''>
              A volunteer earns baseball tickets
            </h2>
          </div>
        </div>

        <div className='text-center'>
          <button className="px-6 py-2 rounded-lg text-white bg-[#0A3400] mx-auto">
            More Good Standing Stories
          </button>
        </div>
      </div>


      <div className='sm:p-16 px-4 border-t-2 border_dark p-8 hidden md:block'>
        <h3 className='text-[#0A3400] pb-8 text-xl font-bold font_family'>Follow along on instagram</h3>

        <div className="flex flex-wrap gap-5">
          {boxes.map((_, index) => (
            <div
              key={index}
              className="rounded-xl bg-black w-[153px] h-[153px] mx-auto"
            ></div>
          ))}
        </div>
      </div>

      <div className='sm:p-16 px-4 border-t-2 border_dark p-8 block md:hidden'>
        <h3 className='text-[#0A3400] pb-8 text-xl font-bold font_family'>Follow along on instagram</h3>

       <BoxSlider/>
      </div>

    </div >
  )
}

export default Home